import BaseController from "confinus_ui/base_controller";

export default class MessageItemController extends BaseController {
  public static values = {
    sentAt: { type: String, default: null },
    senderUid: { type: String, default: null },
    messageType: { type: String, default: null },
    eventType: { type: String, default: null },
    messageEncodedId: { type: String, default: null },
  };

  declare private readonly sentAtValue: any;
  declare private readonly senderUidValue: any;
  declare private readonly messageTypeValue: any;
  declare private readonly eventTypeValue: any;
  declare private readonly messageEncodedIdValue: any;
  public get sentAt(): number {
    return Number(this.sentAtValue);
  }

  public get senderUid(): string {
    return this.senderUidValue!;
  }

  public get messageType(): string {
    return this.messageTypeValue || "Message";
  }

  public get eventType(): string | null {
    return this.eventTypeValue;
  }

  public get encoded_id(): string {
    return this.messageEncodedIdValue!;
  }
}
